<template>
  <v-menu
    v-if="hasAnyItemsInMenu"
    v-model="showingMenu"
    v-bind:close-on-content-click="false"
    location="bottom"
    :offset="8"
    eager
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>

    <v-list data-cy="pods-share--list">
      <v-list-item
        v-if="canControlAccesslinks && getCurrentNode"
        @click="showAccessLinkCreateDialog"
        data-cy="node-tools-bar-share-shareSelected"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-share-circle</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.node.shareFiles', 1) }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canListAccesslinks && getCurrentNode"
        @click="showAccessLinksListDialog"
        data-cy="node-tools-bar-share-accessLinks"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-share-all</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.node.listSharedFiles') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <AccesslinkCreateDialog
    v-if="getCurrentNode && pod"
    v-model="showingAccessLinkCreateDialog"
    :rootNode="getCurrentNode"
    :selectedPods="[pod]"
    :selectedNodes="[]"
  />

  <AccesslinksListDialog
    v-if="getCurrentNode && pod"
    v-model="showingAccessLinkListDialog"
    :node="getCurrentNode"
    :pod="pod"
  />
</template>

<script>
import { useNodeStore } from '@/stores/NodeStore.js';
import AccesslinkCreateDialog from '../../../nodes2/components/dialogs/AccesslinkCreateDialog.vue'
import AccesslinksListDialog from '../../../nodes2/components/dialogs/AccesslinksListDialog.vue'

export default {
  name: "ShareContextMenu",
  components: {
    AccesslinkCreateDialog,
    AccesslinksListDialog,
  },
  props: {
    pod: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      showingMenu: false,
      showingAccessLinkCreateDialog: false,
      showingAccessLinkListDialog: false,
    }
  },
  methods: {
    showAccessLinkCreateDialog: function() {
      this.showingAccessLinkCreateDialog = true;
      this.showingMenu = false;
    },
    showAccessLinksListDialog: function() {
      this.showingAccessLinkListDialog = true;
      this.showingMenu = false;
    },
  },
  computed: {
    getCurrentNode: function() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    hasAnyItemsInMenu: function() {
      return this.canListAccesslinks || this.canControlAccesslinks;
    },
    canListAccesslinks() {
      return  this.$canListNodeAndPod() &&
              this.$canListShareLinks();
    },
    canControlAccesslinks() {
      return  this.$canListNodeAndPod() &&
              this.$canControlNodeAndPod() &&
              this.$canListShareLinks() &&
              this.$canControlShareLinks();
    },
  }
}
</script>

<style>
</style>
